import { Button } from "@mui/material";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
export const RPMButton = ({ link = null, action = null, linktext, type = "contained", size = "medium", sx = {} }) => {

    //sx={{ borderRadius: "2rem", px: 3, py: 2, mt: 2, width: "100%", backgroundColor: "primary", color: theme.palette.text.default }}

    const goToAnchor = (anchor) => {
        //strip the # from the anchor

        console.log("goToAnchor", anchor);
        anchor = anchor.replace('#', '');

        const element = document.getElementById(anchor);
        if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        }
    }

    const containedSX = {
        borderRadius: "0.5rem",
        textTransform: "none",
        backgroundColor: "#5C33D7",
        color: "#fff",
        "&:hover": {
            backgroundColor: "#4C1D95",
        },
        px: 3,
        py: 1.5,
        my: 1,
        width: "100%",
        maxWidth: "500px"

    }

    const textSX = {
        textTransform: "none",
        fontWeight: "bold",
        "&:hover": {
            textDecoration: "underline",
            backgroundColor: "transparent"
        },
        maxWidth: "500px",
        px: 0
    }

    const outlinedSX = {
        borderRadius: "0.5rem",
        textTransform: "none",
        px: 3,
        py: 1.5,
        my: 1,
        borderColor: "#5C33D7",
        color: "#5C33D7",
        "&:hover": {
            borderColor: "#4C1D95",
            color: "#4C1D95",
            backgroundColor: "rgba(92, 51, 215, 0.04)"
        },
        width: "100%",
        maxWidth: "500px"
    }

    const containedContrastSX = {
        borderRadius: "0.5rem",
        textTransform: "none",
        backgroundColor: (theme) => theme.palette.text.primary,
        color: (theme) => theme.palette.background.default,
        "&:hover": {
            backgroundColor: (theme) => theme.palette.text.primary,
            opacity: 0.85
        },
        px: 3,
        py: 1.5,
        my: 1,
        width: "100%",
        maxWidth: "500px"
    }

    const outlinedContrastSX = {
        borderRadius: "0.5rem",
        textTransform: "none",
        px: 3,
        py: 1.5,
        my: 1,
        borderWidth: 1.5,
        borderColor: (theme) => theme.palette.text.primary,
        color: (theme) => theme.palette.text.primary,
        "&:hover": {
            borderWidth: 1.5,
            borderColor: (theme) => theme.palette.text.primary,
            backgroundColor: "rgba(0, 0, 0, 0.06)"
        },
        width: "100%",
        maxWidth: "500px"
    }

    const defaultSx =
        type === "text" ? textSX :
        type === "outlined" ? outlinedSX :
        type === "outlined-contrast" ? outlinedContrastSX :
        type === "contained-contrast" ? containedContrastSX :
        containedSX;

    const muiVariant =
        type === "text" ? "text" :
        type === "outlined" || type === "outlined-contrast" ? "outlined" :
        "contained";

    console.log("defaultSx", defaultSx);

    const msx = { ...defaultSx, ...sx };

    console.log("sx", sx);

    const fixAnchorLinksOld = (link) => {
        if (!link) return null;
        if (link.includes('https://#')) {
            return link.replace('https://#', '#');
        }
        return link;
    }

    const fixAnchorLinks = (link) => {
        console.log("fixAnchorLinks", link)
        if (!link) return { navlink: null, isAnchor: false };

        let navlink = link;
        let isAnchor = false;

        if (link.includes('#')) {
            console.log("fixAnchorLinks is anchor", link)
            navlink = link.split("#")[1];
            isAnchor = true;
        }
        return { navlink, isAnchor };
    }

    const { navlink, isAnchor } = fixAnchorLinks(link?.url);

    console.log("navlink", navlink, isAnchor);


    return (
        <Button
            variant={muiVariant}
            href={ isAnchor ? null : navlink}
            onClick={ isAnchor ? () => goToAnchor(navlink) : action ? action() : null}
            target={link?.target ? link?.target : "_self"}
            size={size}
            sx={msx}
        >
            {linktext}{link?.target === "_blank" && <OpenInNewIcon sx={{ ml: 1, fontSize: "1.2rem" }} />}
        </Button>
    );
}